import { PaymentState } from './subscription-context';

// ----------------------------------------------------------------------
// Single source of truth for the grace period. The banners, the hard paywall
// and the billing page all read the stage from here.
// ----------------------------------------------------------------------

/** How early before the due date the "payment upcoming" notice appears. */
export const PAYMENT_UPCOMING_WINDOW_DAYS = 7;

/** Days past the due date after which the platform is fully blocked. */
export const PAYMENT_BLOCK_AFTER_DAYS = 7;

const DAY_MS = 24 * 60 * 60 * 1000;

export const derivePaymentState = (daysOverdue: number, dueDate: string): PaymentState => {
  if (daysOverdue >= PAYMENT_BLOCK_AFTER_DAYS) return 'blocked';
  if (daysOverdue >= 1) return 'overdue';

  const msUntilDue = new Date(dueDate).getTime() - Date.now();
  if (msUntilDue > 0 && msUntilDue <= PAYMENT_UPCOMING_WINDOW_DAYS * DAY_MS) return 'upcoming';

  return 'idle';
};
